export const SHOP_LOCATOR = 'https://shoplocator.williamhill';
export const PODCAST = 'https://podcasts.apple.com/gb/podcast/stripped-with-specs-and-vuj/id1637248161';
